// src/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';

export default function PrivateRoute({ children }) {
  const { hydrated, token } = useContext(AuthContext);

  if (!hydrated) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <div className="text-slate-600 text-sm">Loading…</div>
      </div>
    );
  }

  // IMPORTANT: If backend is down but token exists, allow access.
  if (!token) return <Navigate to="/login" replace />;

  return children;
}
